enum MenuOption {
  None = 'none',
  Price = 'Payment & Price',
  Make = 'Make & Model',
  Body = 'Body Type'
}

export default MenuOption;
